// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ea95243","732":"92e5080e","977":"560c6195"}[chunkId] + ".chunk.js";
};